(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["question.profile.htm"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "needsDiffAnswer")) {
output += "\r\n\t<p class=\"warning\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"question")),"needs_different_answer"), env.opts.autoescape);
output += "</p>\r\n";
;
}
output += "\r\n\r\n<h3>Q.";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "currentQuestion"), env.opts.autoescape);
output += "<span class=\"visible-xs-inline\"> / ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "nQuestionsTotal"), env.opts.autoescape);
output += "</span>";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"lang") == "fr") {
output += " ";
;
}
output += ": ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "question"), env.opts.autoescape);
output += "</h3>\r\n<h5>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"question")),"do_you_agree"), env.opts.autoescape);
output += "</h5>\r\n\r\n<div class=\"answer profil-answer\">\r\n\t<div>";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"question")),"not_agree")), env.opts.autoescape);
output += "</div>\r\n\t<span class=\"button-radio\" name=\"radio_0\" type=\"radio\" data-option=\"1\"> </span>\r\n\t<span class=\"button-radio\" name=\"radio_0\" type=\"radio\" data-option=\"2\"> </span>\r\n\t<span class=\"button-radio\" name=\"radio_0\" type=\"radio\" data-option=\"3\"> </span>\r\n\t<span class=\"button-radio\" name=\"radio_0\" type=\"radio\" data-option=\"4\"> </span>\r\n\t<div>";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"question")),"agree")), env.opts.autoescape);
output += "</div>\r\n</div>\r\n\r\n";
if(runtime.contextOrFrameLookup(context, frame, "currentQuestion") > 1) {
output += "\r\n<p class=\"q-back\"><a href=\"#\">Retour</a></p>\r\n";
;
}
output += "\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
